import React, { createContext, useContext, useMemo, useState } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { createAppTheme } from './createAppTheme';

const STORAGE_KEY = 'visitorapi-theme-mode';
const ThemeModeReactContext = createContext(null);

function readStoredMode() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function ThemeModeProvider({ children }) {
  const [mode, setMode] = useState(readStoredMode);

  const toggleMode = () => {
    setMode((prev) => {
      const next = prev === 'light' ? 'dark' : 'light';
      try {
        window.localStorage.setItem(STORAGE_KEY, next);
      } catch {
        // localStorage unavailable (private browsing, etc.) — mode still
        // updates for this session, it just won't persist.
      }
      return next;
    });
  };

  const theme = useMemo(() => createAppTheme(mode), [mode]);

  return (
    <ThemeModeReactContext.Provider value={{ mode, toggleMode }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeModeReactContext.Provider>
  );
}

export function useThemeMode() {
  const ctx = useContext(ThemeModeReactContext);
  if (!ctx) {
    throw new Error('useThemeMode must be used inside a ThemeModeProvider');
  }
  return ctx;
}
